import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  ComponentSingleStyleConfig,
  Input,
  useStyleConfig,
} from "@chakra-ui/react";
import {
  createTimeStr,
  timeTextToTimeOrNull,
} from "../../../lib/util/common-date-util";
import { hasValue } from "../../../lib/util/common-util";

export type CMTimePickerProps = {
  size?: "sm" | "md" | "lg";

  placeholder?: string;

  selected?: { hour: number; minute: number } | null;

  disabled?: boolean;
  isInvalid?: boolean;

  onChange?: (value: { hour: number; minute: number } | null) => void;

  onBlur?: () => void;
} & ComponentStyleProps;
export const CMTimePicker = ({
  size = "md",

  placeholder,

  selected = null,

  disabled,
  isInvalid,

  onChange,

  onBlur,

  sx,

  ...rest
}: CMTimePickerProps) => {
  const styles = useStyleConfig("CMTimePickerStyles");

  const selectedText = useMemo(
    () =>
      hasValue(selected) ? createTimeStr(selected.hour, selected.minute) : "",
    [selected],
  );
  const [textValue, setTextValue] = useState<string>(selectedText);

  useEffect(() => {
    setTextValue(selectedText);
  }, [selectedText]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setTextValue(value);

      const time = timeTextToTimeOrNull(value);
      if (hasValue(time)) onChange?.(time);
    },
    [onChange, setTextValue],
  );

  /**
   * キーボードから入力値がクリアされた場合の処理
   * @param e キーボードイベント
   */
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // 処理対象のイベント
    if (e.key === "Backspace" || e.key === "Delete") {
      // 入力値をクリアし、呼び出し元へ通知
      // setTextValueをクリアすると、入力された時刻すべてがクリアされるためonChangeのみ実行
      onChange?.(null);
    }
  };

  return (
    <Input
      type="time"
      size={size}
      disabled={disabled}
      isInvalid={isInvalid}
      value={textValue}
      onChange={handleChange}
      onKeyDown={handleKeyPress}
      onBlur={onBlur}
      placeholder={placeholder}
      sx={{ ...styles, ...sx }}
      {...rest}
    />
  );
};
export const CMTimePickerStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    w: "150px",
  },
};
